<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.activity') }}
			</div>
			<v-row>
				<v-col cols="12">
					<Dropdown
						:readonly="!canEdit"
						v-model="teacherActivity.teacher_id"
						:ajax="true"
						:data="'teachers/' + plannedCourseId"
						:errorBorder="!teacherActivityValidation.teacher_id"
						:label="'* ' + $t('fields.teacher')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!canEdit"
						v-model="teacherActivity.description"
						:errorBorder="!teacherActivityValidation.description"
						:label="'* ' + $t('fields.description')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<DatePicker
						:readonly="!canEdit"
						v-model="teacherActivity.date"
						:errorBorder="!teacherActivityValidation.date"
						:date-label="'* ' + $t('fields.date')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<NumberField
						:readonly="!canEdit"
						v-model="teacherActivity.hours"
						:precision="2"
						:errorBorder="!teacherActivityValidation.hours"
						:label="'* ' + $t('fields.hours')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<CheckBox
						:readonly="!canEdit"
						v-model="teacherActivity.billing"
						:label="$t('fields.billing')"
					></CheckBox>
				</v-col>
				<v-row v-if="teacherActivity.billing == true">
					<v-col cols="2">
						<div :class="['text-body-1', 'pt-5']">
							{{ $t('labels.hourRateType') }}
						</div>
					</v-col>
					<v-col cols="10">
						<v-radio-group :readonly="!canEdit" v-model="teacherActivity.hour_rate_type" row mandatory>
							<v-radio :label="$t('fields.t1')" value="T1"></v-radio>
							<v-radio :label="$t('fields.t2')" value="T2"></v-radio>
							<v-radio :label="$t('fields.t3')" value="T3"></v-radio>
							<v-radio :label="$t('fields.t4')" value="T4"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn v-if="canEdit" class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import InputField from '../../trinkets/InputField';
import Dropdown from '../../trinkets/Dropdown';
import CheckBox from '../../trinkets/CheckBox';
import DatePicker from '../../trinkets/DatePicker';
import NumberField from '../../trinkets/NumberField';
import TeacherActivity from '../../../models/TeacherActivity';

export default {
	name: 'TeacherActivity',
	components: { NumberField, DatePicker, InputField, CheckBox, Dropdown },
	props: {
		activityId: [String, Number],
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	emits: ['close', 'reloadTeacherActivities'],
	data() {
		return {
			teacherActivity: new TeacherActivity({ id: this.activityId }),
			teacherActivityValidation: new TeacherActivity({}, true),
			t1: null,
			t2: null,
			t3: null,
			t4: null,
		};
	},
	watch: {
		'teacherActivity.teacher_id': function (newVal) {
			if (newVal) {
				this.getTeacher();
			}
		},
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getTeacherActivity() {
			var vm = this;
			this.$APICall(
				'get',
				'teacher-activities/' + this.activityId,
				{},
				(data, success) => {
					if (success) {
						vm.teacherActivity = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		getTeacher() {
			var vm = this;
			this.$APICall('get', 'teachers/' + this.teacherActivity.teacher_id, {}, (data, success) => {
				if (success) {
					this.t1 = data.item.t1;
					this.t2 = data.item.t2;
					this.t3 = data.item.t3;
					this.t4 = data.item.t4;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.teacherActivity.description == null || this.teacherActivity.description == '') {
				success = false;
				this.teacherActivityValidation.description = false;
			} else {
				if (this.teacherActivity.description.length > 500) {
					this.teacherActivityValidation.description = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.description'))
							.replace('%length%', '500') + '<br />';
				} else {
					this.teacherActivityValidation.description = true;
				}
			}

			if (this.teacherActivity.hours == null) {
				success = false;
				this.teacherActivityValidation.hours = false;
			} else {
				let decimalPart = this.teacherActivity.hours % 1;
				if (decimalPart != 0.25 && decimalPart != 0.5 && decimalPart != 0.75 && decimalPart != 0) {
					this.teacherActivityValidation.hours = false;
					errorMessages += this.$t('alerts.hoursError') + '<br />';
				} else {
					this.teacherActivityValidation.hours = true;
				}
			}

			if (!this.teacherActivity.date) {
				success = false;
				this.teacherActivityValidation.date = false;
			} else {
				this.teacherActivityValidation.date = true;
			}

			if (!this.teacherActivity.teacher_id) {
				success = false;
				this.teacherActivityValidation.teacher_id = false;
			} else {
				this.teacherActivityValidation.teacher_id = true;
			}

			if (this.teacherActivity.billing) {
				if (this.teacherActivity.hour_rate_type === 'T1') {
					this.teacherActivity.hour_rate = this.t1;
				} else if (this.teacherActivity.hour_rate_type == 'T2') {
					this.teacherActivity.hour_rate = this.t2;
				} else if (this.teacherActivity.hour_rate_type == 'T3') {
					this.teacherActivity.hour_rate = this.t3;
				} else if (this.teacherActivity.hour_rate_type == 'T4') {
					this.teacherActivity.hour_rate = this.t4;
				} else {
					this.teacherActivity.hour_rate = null;
				}
			} else {
				this.teacherActivity.hour_rate = null;
				this.teacherActivity.hour_rate_type = null;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.teacherActivity.id != 0) {
					action = 'put';
					addition = '/' + vm.teacherActivity.id;
				}
				this.teacherActivity.planned_course_id = this.plannedCourseId;
				this.$APICall(action, 'teacher-activities' + addition, this.teacherActivity, (data, success) => {
					if (success) {
						if (vm.teacherActivity.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$modalBus.$emit('reloadTeacherActivities');
						vm.$modalBus.$emit('reloadCosts');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					this.$emit('close');
				});
			}
		},
	},
	mounted() {
		if (this.activityId !== 0) {
			this.getTeacherActivity();
		}
	},
};
</script>
